import DayCalender from "./DayCalender";
import WeekCalender from "./WeekCalender";
import MonthCalender from "./MonthCalender";
export default {
  DayCalender,
  WeekCalender,
  MonthCalender,
};
